// extracted by mini-css-extract-plugin
export default {"dialog":"PaymentDeclinedDialog_dialog__64K0B","icon":"PaymentDeclinedDialog_icon__OLlxL","formButton":"PaymentDeclinedDialog_formButton__dOSno"};